import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { RoundMedia } from '../../services/backendService/types';

export const ActiveBackgroundContext = createContext<{
  backgroundMedia?: RoundMedia;
  textColor?: string;
  setBackgroundMedia: Dispatch<SetStateAction<RoundMedia | undefined>>;
  setTextColor: Dispatch<SetStateAction<string | undefined>>;
}>({
  backgroundMedia: undefined,
  textColor: undefined,
  setBackgroundMedia: {} as Dispatch<SetStateAction<RoundMedia | undefined>>,
  setTextColor: {} as Dispatch<SetStateAction<string | undefined>>,
});

const ActiveBackgroundProvider = ({ children }: { children: React.ReactNode }) => {
  const [backgroundMedia, setBackgroundMedia] = useState<RoundMedia | undefined>();
  const [textColor, setTextColor] = useState<string | undefined>();
  const value = useMemo(
    () => ({ backgroundMedia, setBackgroundMedia, textColor, setTextColor }),
    [backgroundMedia, textColor],
  );

  useEffect(() => {
    return () => {
      setBackgroundMedia(undefined);
      setTextColor(undefined);
    };
  }, []);
  return (
    <ActiveBackgroundContext.Provider value={value}>
      {children}
    </ActiveBackgroundContext.Provider>
  );
};

export default ActiveBackgroundProvider;
